import React from "react";

const ProductDisplay = ({ stripeData, plan }) => (
  <div className="mb-4">
    <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="stripeProduct">
      Product
    </label>
    <input
      type="text"
      value={stripeData?.find(
        (product) => product.product.id === plan?.stripe_product
      )?.product.name || ''}
      disabled
      className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-gray-100"
    />
  </div>
);

export default ProductDisplay; 